<script setup>
import ApikomTaskTable from '@frontJs/components/tables/projectManagement/tasks/ApikomTaskTable.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import TabLayout from '@js/components/tabs/TabLayout.vue';
import PageTitle from '@js/components/titles/PageTitle.vue';
import { useRoute } from '@js/utils/route';
import { h, onMounted, ref } from 'vue';

const { route } = useRoute();

const loading = ref(true);

const data = ref({
    tasks: 0,
    devToTake: 0,
    devOngoing: 0,
    devClosed: 0,
    closedTasks: 0,
});

function updateData() {
    loading.value = true;

    Promise.all([
        axios.post(route('front.projectManagement.task.postTaskCount'), {
            status: ['open', 'to_process'],
            type: ['hourly', 'package'],
            noOneResponsible: false,
        }),
        axios.post(route('front.projectManagement.task.postTaskCount'), {
            status: ['open', 'to_process'],
            type: ['hourly', 'package'],
            theme: ['dev', 'dev_seo'],
            noOneResponsible: true,
        }),
        axios.post(route('front.projectManagement.task.postTaskCount'), {
            status: ['open', 'to_process'],
            type: ['hourly', 'package'],
            theme: ['dev', 'dev_seo'],
            noOneResponsible: false,
        }),
        axios.post(route('front.projectManagement.task.postTaskCount'), {
            status: 'closed',
            type: ['hourly', 'package'],
            theme: ['dev', 'dev_seo'],
        }),
        axios.post(route('front.projectManagement.task.postTaskCount'), {
            status: 'closed',
            type: ['hourly', 'package'],
        }),
    ])
        .then(
            ([
                tasksData,
                devToTakeData,
                devOngoingData,
                devClosedData,
                closedTasksData,
            ]) => {
                data.value.tasks = tasksData.data.count;
                data.value.devToTake = devToTakeData.data.count;
                data.value.devOngoing = devOngoingData.data.count;
                data.value.devClosed = devClosedData.data.count;
                data.value.closedTasks = closedTasksData.data.count;
            },
        )
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {
            loading.value = false;
        });
}

onMounted(() => {
    updateData();
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>Tâches Apikom - Tâches - Gestion de projet - Datakepler</title>
    </Head>

    <PageTitle>Gestion de projet - Tâches - Tâches Apikom</PageTitle>

    <TabLayout
        :tabs="{
            tasks: {
                title: 'Tâches',
                total: data.tasks,
                content: h(ApikomTaskTable, {
                    userSessionKey: 'tasks',
                    type: ['hourly', 'package'],
                    status: ['open', 'to_process'],
                    createTaskUrl: route(
                        'front.projectManagement.task.createTask',
                    ),
                    noOneResponsible: false,
                }),
            },
            devToTake: {
                title: 'Dev à prendre',
                total: data.devToTake,
                content: h(ApikomTaskTable, {
                    userSessionKey: 'tasks_dev_to_take',
                    type: ['hourly', 'package'],
                    status: ['open', 'to_process'],
                    theme: ['dev', 'dev_seo'],
                    noOneResponsible: true,
                    createTaskUrl: route(
                        'front.projectManagement.task.createTask',
                        {
                            theme: 'dev',
                            noOneResponsible: true,
                        },
                    ),
                }),
            },
            devOngoing: {
                title: 'Dev en cours',
                total: data.devOngoing,
                content: h(ApikomTaskTable, {
                    userSessionKey: 'tasks_dev_ongoing',
                    type: ['hourly', 'package'],
                    status: ['open', 'to_process'],
                    theme: ['dev', 'dev_seo'],
                    noOneResponsible: false,
                    createTaskUrl: route(
                        'front.projectManagement.task.createTask',
                        {
                            theme: 'dev',
                        },
                    ),
                }),
            },
            devClosed: {
                title: 'Dev fermés',
                total: data.devClosed,
                content: h(ApikomTaskTable, {
                    userSessionKey: 'tasks_dev_closed',
                    type: ['hourly', 'package'],
                    status: 'closed',
                    theme: ['dev', 'dev_seo'],
                    createTaskUrl: route(
                        'front.projectManagement.task.createTask',
                        {
                            theme: 'dev',
                        },
                    ),
                }),
            },
            closedTasks: {
                title: 'Tâches fermées',
                total: data.closedTasks,
                content: h(ApikomTaskTable, {
                    userSessionKey: 'tasks_closed',
                    type: ['hourly', 'package'],
                    status: 'closed',
                }),
            },
        }"
        :loading="loading"
    />
</template>
